import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Service, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IData } from '../../models/api/data';
import { IError } from '../../models/error/error';
import { IGetAllLocations, IGetLocationSettings, ILocation, ILocationSetting } from '../../models/location/location';

export const urlGetAllLocations = () => ['clinic', 'admin', 'laboratory', 'location'];
export const urlGetAllSelectLocations = () => ['clinic', 'admin', 'laboratory', 'location', 'select'];
export const urlGetLocationSettings = (locationId: string) => ['clinic', 'admin', 'laboratory', 'location', locationId, 'settings'];

@Service()
export class LocationService {
    private readonly router = inject(Router);
    private readonly httpClient = inject(HttpClient);

    public getAllLocations(data: IGetAllLocations): Observable<IData<ILocation[]>> {
        const url = this.router.createUrlTree(urlGetAllLocations(), {
            queryParams: data,
        });

        const parsedUrl = `${environment.apiUrl}/${environment.apiVersion}${url}`;

        return this.httpClient.get<IData<ILocation[]>>(parsedUrl, { responseType: 'json' }).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.error instanceof ErrorEvent) {
                    return throwError(() => `Error: ${error.error.message}`);
                }
                const errorApi: IError = error.error.error;
                return throwError(() => errorApi);
            }),
        );
    }

    public getLocationSettings(data: IGetLocationSettings): Observable<IData<ILocationSetting>> {
        const { locationId, ...queryParams } = data;
        const url = this.router.createUrlTree(urlGetLocationSettings(locationId), {
            queryParams,
        });

        const parsedUrl = `${environment.apiUrl}/${environment.apiVersion}${url}`;

        return this.httpClient.get<IData<ILocationSetting>>(parsedUrl, { responseType: 'json' }).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.error instanceof ErrorEvent) {
                    return throwError(() => `Error: ${error.error.message}`);
                }
                const errorApi: IError = error.error.error;
                return throwError(() => errorApi);
            }),
        );
    }
}
